var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16667 1.83398H6.5L8.16667 6.00065L6.08333 7.25065C6.9758 9.06026 8.44039 10.5249 10.25 11.4173L11.5 9.33398L15.6667 11.0007V14.334C15.6667 14.776 15.4911 15.1999 15.1785 15.5125C14.866 15.8251 14.442 16.0007 14 16.0007C10.7494 15.8031 7.68346 14.4227 5.38069 12.12C3.07792 9.81719 1.69754 6.75126 1.5 3.50065C1.5 3.05862 1.67559 2.6347 1.98816 2.32214C2.30072 2.00958 2.72464 1.83398 3.16667 1.83398Z",
    stroke: "#173058",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.364f2d78c66be697696cc190c5fd44b7.svg";
export { ForwardRef as ReactComponent };